/**
 * Autogenerated file don't modify
 */
(function () {
(function () {
    'use strict';

    MoyaComponents.register('ecar.filter.form', function (el) {
        el.querySelectorAll('select').forEach(function (select) {
            select.addEventListener('change', function () {
                el.submit();
            });
            if (select.classList.contains('active')) {
                select.closest('.elm').classList.add('active');
            }
        });
        el.querySelectorAll('input').forEach(function (input) {
            input.addEventListener('onchange', function () {
                el.submit();
            });
        });
    });

}());
typeof tsBuild === 'function' && tsBuild();})();
